import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter, map, Observable, Subject, takeUntil } from 'rxjs';
import { RouteData } from '../entities/route';

@Injectable({ providedIn: 'root' })
export class RouteDataService {
    private route!: ActivatedRoute;
    private router!: Router;

    private readonly destroy$ = new Subject<void>();

    private routeDataSubj$ = new BehaviorSubject<RouteData>({});

    get routeData$(): Observable<RouteData> {
        return this.routeDataSubj$;
    }

    get hideSideMenu$(): Observable<boolean> {
        return this.routeData$.pipe(map((data) => data.hideSideMenu));
    }

    get hideHeader$(): Observable<boolean> {
        return this.routeData$.pipe(map((data) => data.hideHeader));
    }

    init(route: ActivatedRoute, router: Router) {
        this.route = route;
        this.router = router;

        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                takeUntil(this.destroy$)
            )
            .subscribe(() => {
                this.routeDataSubj$.next(this.collectDeepRouteData(this.route.snapshot));
            });
    }

    destroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    collectDeepRouteData(route: ActivatedRouteSnapshot, data: RouteData = {}): RouteData {
        if (!route) {
            return data;
        }

        return this.collectDeepRouteData(route.children[0], { ...data, ...route.data });
    }
}
